import React__default from 'react';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import { FONT_WEIGHTS } from '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import { getRemValue } from '../../methods/getRemValue.js';
import 'bowser';
import '../../_virtual/_tslib.js';
import '../toast/toast.js';
import '../../_services/auth.service.js';
import '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../constants/StateList.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import '../../constants/serviceTypeId.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import '../../_services/const.js';

const ImageText = ({ text, style, count, path, alt, plusVisible, imageStyle, imageVisible, isMobile = false }) => {
    return (React__default.createElement("div", { style: Object.assign({ padding: `0 12px`, height: "30px", width: "fit-content", borderRadius: "50px", backgroundColor: "rgba(155, 155, 155, 0.1)", color: "rgba(10, 34, 57, 0.6)", display: "flex", alignItems: "center" }, style) },
        imageVisible ? path : null,
        React__default.createElement("div", { style: {
                fontWeight: FONT_WEIGHTS.bold,
                fontSize: isMobile ? getRemValue(10) : getRemValue(12),
                letterSpacing: isMobile ? getRemValue(-0.1) : getRemValue(-0.12),
                lineHeight: isMobile ? "13px" : "16px",
                color: "#08123B",
                opacity: 0.75,
                whiteSpace: "nowrap"
            } },
            count,
            plusVisible ? "+" : null,
            " ",
            text)));
};

export { ImageText as default };
//# sourceMappingURL=ImageText.js.map
